import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  justify-content: center;
  align-items: center;
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 5px solid #564DE6;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default function Loader() {
  return <Container>
    <Spinner></Spinner>
    <span style={{color: "#564de6"}}>이미지를 불러오고 있습니다.</span>
  </Container>
}